/**
 * True when an error means the session is gone and the user must re-authenticate.
 *
 * Matched by Auth0 identity (OAuth code, refresh-token message, error_description)
 * or an HTTP 401 — NOT by HTTP 403. Auth0 surfaces the dead-refresh-token 403 from
 * /oauth/token as a plain Error with no recognized code, while a BFF 403 means
 * authenticated-but-forbidden and must stay on the permission/fatal path rather
 * than bounce to login.
 *
 * Shared by AuthGuardAuthenticatedGate (the useAuth0().error channel) and
 * AuthErrorBoundary (thrown query/interceptor errors) so both classify failures
 * identically.
 */
export const isAuthRejection = (error: unknown): boolean => {
  const auth0Error = (error as { error?: string })?.error
  const status = (error as { status?: number })?.status
  const responseStatus = (error as { response?: { status?: number } })?.response?.status
  const message = (error as { message?: string })?.message ?? ''
  const errorDescription = (error as { error_description?: string })?.error_description ?? ''

  return (
    auth0Error === 'invalid_grant' ||
    auth0Error === 'login_required' ||
    status === 401 ||
    responseStatus === 401 ||
    /invalid.*refresh.*token/i.test(message) ||
    /invalid.*refresh.*token/i.test(errorDescription)
  )
}
